import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';

import 'rxjs/add/operator/toPromise';

import { URL_API } from './../constante';
import { HEADERS_GET } from './../constante';
import { HEADERS } from './../constante';
import { Usuario } from '../usuario/usuario';

@Injectable()
export class UsuariosService {

  private headers = HEADERS_GET;
  private usuarioUrl = URL_API + "/usuarios";
  private perfisUrl = URL_API + "/perfisacesso";

  constructor ( private http: Http, private _flashMessagesService: FlashMessagesService ) { }

  getUsuarios(): Promise<Usuario[]> {

        return this.http.get(this.usuarioUrl)
                    .toPromise()
                    .then(response => response.json() as Usuario[])
                    .catch((error) => this.handleError(error));
  }

  getUsuario(id): Promise<Usuario> {
        return this.http.get(this.usuarioUrl+'/'+id)
                    .toPromise()
                    .then(response => response.json() as Usuario)
                    .catch((error) => this.handleError(error));
  }

  getPerfisAcesso(): Promise<Usuario[]> {
        return this.http.get(this.perfisUrl)
                    .toPromise()
                    .then(response => response.json() as Usuario[])
                    .catch(this.handleError);
  }

  saveUsuario(usuario: Usuario):Promise<Usuario> {
    let url: string = this.usuarioUrl + '/save/' + usuario.id;

		return this.http
		   .post(url, JSON.stringify(usuario), {headers: HEADERS})
		   .toPromise()
		   .then(response => this.handleSuccess(response.json().msg))
		   .catch((error) => this.handleError(error));
  }

  removeUsuario(id_usuario: string):Promise<any> {
    let url: string = this.usuarioUrl + '/remove/' + id_usuario;

		return this.http
		   .post(url, JSON.stringify(id_usuario), {headers: HEADERS})
		   .toPromise()
		   .then(response => this.handleSuccess(response.json().msg))
		   .catch((error) => this.handleError(error));
  }

  addUsuario(usuario: Usuario):Promise<Usuario> {
    let url: string = this.usuarioUrl + '/add/';

		return this.http
		   .post(url, JSON.stringify(usuario), {headers: HEADERS})
		   .toPromise()
		   .then(response => this.handleSuccess(response.json().msg))
		   .catch((error) => this.handleError(error));
  }

	private handleSuccess(resp: any): Promise<any> {
	  this._flashMessagesService.show(resp, { cssClass: 'alert-success', timeout: 30000 });
	  return resp;
	}

  handleError(error: any): Promise<any> {
    console.error('An error occurred',error);
    try {
      this._flashMessagesService.show(error.json().msg, { cssClass: 'alert-danger', timeout: 30000 });
    } catch (e) {
      this._flashMessagesService.show(error.message, { cssClass: 'alert-danger', timeout: 30000 });
    }

    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/usuarios/usuarios.service.ts